import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { useHistory } from "react-router-dom";

export const FacturarEquipoScreen = () => {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [data, setData] = useState([]);
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get("FacturarEquipo/Obtener_Solicitudes")
      .then((result) => {
        setData(result);
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION DE EQUIPOS", JSON.stringify(error), "error");
      });
  }, []);
  const onFacturar = (folio, cliente, vendedor) => {
    history.push("/Credito/facturarequipo", {
      folio,
      cliente,
      vendedor,
    });
  };
  return (
    <PlantillaScreen
      titulo={`LISTADO DE CREDITOS A FACTURAR`}
      className={"listado-equiposfacturar-screen"}
      className_main={1}
    >
      <div className="container-listado-creditos-facturar">
        <LoaderScreen loader={loader} />
        <div className="container-listado-creditos-facturar-table scroll-4">
          {data === undefined || data === null || data.length === 0 ? (
            <div></div>
          ) : (
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>Sucursal</th>
                  <th>
                    <div>Vendedor</div>
                  </th>
                  <th>
                    <div>Cliente</div>
                  </th>
                  <th>
                    <div>Fecha</div>
                  </th>
                  <th className="ta-rigth">
                    <div>Importe</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((fac) => (
                  <tr
                    onClick={() =>
                      onFacturar(fac.folio, fac.cliente, fac.vendedor)
                    }
                  >
                    <td>{fac.sucursal}</td>
                    <td>{fac.vendedor}</td>
                    <td>{fac.cliente}</td>
                    <td className="ta-center">{fac.fecha}</td>
                    <td>{FormatMoney(fac.importe)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </PlantillaScreen>
  );
};
